import React, { createContext, useState, ReactNode, useContext, useEffect } from "react";
import MailAPI from "../api.ts";

interface MailContextType {
  mail: string;
  setMail: (mail: string) => void;
  isAuthenticated: boolean;
  setAuthenticated: (auth: boolean) => void;
  logout: () => void;
}

const api = new MailAPI();
const MailContext = createContext<MailContextType | undefined>(undefined);

export const MailProvider = ({ children }: { children: ReactNode }) => {
  const storedMail = localStorage.getItem("mail") || "";
  const [mail, setMailState] = useState<string>(storedMail);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(api.isAuthenticated());

  const setMail = (newMail: string) => {
    localStorage.setItem("mail", newMail);
    setMailState(newMail);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('mail');
    setMailState('');
    setIsAuthenticated(false);
  };

  useEffect(() => {
    setIsAuthenticated(api.isAuthenticated());
  }, []);

  // Manually set authentication status
  const setAuthenticated = (auth: boolean) => {
    setIsAuthenticated(auth);
    if (!auth) {
      localStorage.removeItem('token');
    }
  };

  return (
    <MailContext.Provider value={{ mail, setMail, isAuthenticated, setAuthenticated, logout }}>
      {children}
    </MailContext.Provider>
  );
};

export const useMail = () => {
  const context = useContext(MailContext);
  if (!context) {
    throw new Error("useMail must be used within a MailProvider");
  }
  return context;
};